import Vue from 'vue'

Vue.mixin({
    methods: {
        dateToString: (someDate: any) => {
            if (!someDate) return "";
            if (someDate == null) return "";
            const ddd = new Date("" + someDate);
            const mm = ddd.getMonth() + 1; // getMonth() is zero-based
            const dd = ddd.getDate();
            return mm + "/" + dd + "/" + ddd.getFullYear();
        },
    }
})
